import React, { createContext, useContext } from 'react'

// @ts-expect-error TS(2554) FIXME: Expected 1 arguments, but got 0.
const AccountContext = createContext()
// @ts-expect-error TS(7031) FIXME: Binding element 'children' implicitly has an 'any'... Remove this comment to see the full error message
function Provider({ children, value }) {
  return (
    <AccountContext.Provider value={value}>{children}</AccountContext.Provider>
  )
}

function useAccountContext() {
  const context = useContext(AccountContext)
  if (context === undefined) {
    throw new Error('useAccountContext must be used within a AccountContext')
  }
  return context
}

export { Provider, useAccountContext }
